import { IS_MOBILE } from "const/common";
import Image from "next/image";
import { useEffect, useState } from "react";
import GradientTextWithBall from "./common/GradientTextWithBall";
import SpaceWrapper from "./common/SpaceWrapper";

const DesignProcess = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
  }, []);
  return (
    <SpaceWrapper className="pt-12 px-6 md:py-12 md:px-10 xl:px-48 xl:pb-12 xl:pt-0">
      <GradientTextWithBall text={<>Design Process</>} />
      {isMobile ? (
        <div className="mt-12 fs-0">
          <Image
            alt="Roadside service assistance app design timeline"
            loading="lazy"
            src="/assets/case-study/roaddy/graph-mobile.webp"
            width={862}
            height={1614}
          />
        </div>
      ) : (
        <div className="pt-32 flex justify-center fs-0">
          <Image
            alt="Roadside service assistance app design timeline"
            loading="lazy"
            src="/assets/case-study/roaddy/graph.webp"
            width={1528}
            height={837}
          />
        </div>
      )}
    </SpaceWrapper>
  );
};
export default DesignProcess;
